import { render, staticRenderFns } from "./TaskEdit.vue?vue&type=template&id=2f137f72&scoped=true&"
import script from "./TaskEdit.vue?vue&type=script&setup=true&lang=js&"
export * from "./TaskEdit.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f137f72",
  null
  
)

export default component.exports